import { MainContainer, ParentContainer } from "./styled"
import Sidemenu from "../../components/Sidemenu/Sidemenu"
import AppRoutes from "../../app/routes"
import Toast from "../Toast"
import VersionDailog from "../VersionDialog"
import { useAppSelector } from "../../app/hooks"

export default function Layout() {
  const { token, role } = useAppSelector((state) => state.login)

  return (
    <ParentContainer>
      {token && <Sidemenu />}
      <MainContainer>
        <AppRoutes token={token} role={role} />
      </MainContainer>
      <Toast />
      <VersionDailog />
    </ParentContainer>
  )
}
